export default function cloneNotEmpty (obj) {
  let o = {}

  for (let key in obj) {
    if (['milestone'].includes(key)) {
    } else if (key === 'tags') {
      if (obj[key].length > 0) o[key] = obj[key]
    } else if (obj[key] || obj[key] === '') {
      o[key] = obj[key]
    }
  }

  return o
}